import { ToastType } from 'react-toastify';

import type { Template } from '@feathr/blackbox';
import { toast } from '@feathr/components';

interface IToastMessageProps {
  updatedTemplate: Template;
  successMessage: string;
  errorMessage: string;
}

export function toastMessage({
  updatedTemplate,
  successMessage,
  errorMessage,
}: IToastMessageProps): void {
  if (updatedTemplate.isErrored) {
    toast(errorMessage, {
      type: ToastType.ERROR,
    });
  } else {
    toast(successMessage, { type: ToastType.SUCCESS });
  }
}
